import { REDO_ONBOARDING_APP_URL } from "@redotech/redo-merchant-app-common/config";
import {
  ONBOARDING_RESUME_SOURCE_PARAM,
  type OnboardingResumeSource,
} from "@redotech/redo-onboarding-api/resume-source";

// First-install onboarding now lives in welcome/welcome-page.tsx, entered via
// onboarding/first-install-redirect-guard.tsx. This module keeps only the URL builder.

/** Builds an onboarding-app URL with the merchant auth handoff in query params. */
export function autoOnboardingUrl(
  token: string,
  teamId: string,
  resumeSource?: OnboardingResumeSource,
) {
  const url = new URL(REDO_ONBOARDING_APP_URL);
  url.searchParams.set("token", token);
  url.searchParams.set("teamId", teamId);
  if (resumeSource) {
    url.searchParams.set(ONBOARDING_RESUME_SOURCE_PARAM, resumeSource);
  }
  return url;
}
